import { apiClient } from "../../../lib/apiClient";
import type { ApiResponse } from "../../../types/apiResponse";
import type { ProductData } from "../types";

export const editProduct = async (data: ProductData): Promise<ApiResponse> => {
    return await apiClient("/v1/catalogs/product", {
        method: "PUT",
        headers: {
            "Content-Type": "application/json",
        },
        body: data,
    });
};
